import React from "react"
import Container from "./IconContainer"


const PhoneIcon = ({ ...props }) => (
  <Container {...props}>
    <svg
      width="15px"
      height="15px"
      viewBox="0 0 15 15"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="190701"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="2_NYT-Dashboard-D"
          transform="translate(-106.000000, -1482.000000)"
          stroke="#505050"
          strokeWidth="1.5"
        >
          <g id="phone" transform="translate(107.000000, 1483.000000)">
            <path
              d="M12.9995918,9.75231198 L12.9995918,11.7132197 C13.0010859,12.0813116 12.847326,12.4329763 12.5760866,12.6818198 C12.3048473,12.9306632 11.9412663,13.0536231 11.5746655,13.0204915 C9.56331927,12.8019423 7.63127957,12.1146466 5.93378767,11.0138293 C4.35449098,10.0102784 3.01552307,8.67131054 2.01197224,7.09201384 C0.907313213,5.38681109 0.219861418,3.44537557 0.00531000588,1.42499054 C-0.0277161181,1.05952462 0.0943822833,0.697005133 0.341779402,0.425987184 C0.589176522,0.154969234 0.939090496,0.000409835714 1.30604546,-1.86517468e-14 L3.26695318,-1.86517468e-14 C3.92311477,-0.00639376068 4.48238969,0.474582678 4.57422499,1.12431802 C4.65699034,1.75185193 4.81048133,2.36800863 5.03177012,2.96103492 C5.21134678,3.43876108 5.09648993,3.97731212 4.73763396,4.34020668 L3.90751636,5.17032428 C4.83800333,6.80673172 6.19292435,8.16165274 7.8293318,9.09213971 L8.6594494,8.26202211 C9.02234396,7.90316615 9.560895,7.78830929 10.0386212,7.96788596 C10.6316474,8.18917475 11.2478041,8.34266574 11.8753381,8.42543109 C12.5326099,8.51815609 13.0160569,9.08873596 12.9995918,9.75231198 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  </Container>
)

export default PhoneIcon


// WEBPACK FOOTER //
// ./assets/common/components/icons/PhoneIcon.js